export default function updateFieldForObjects(
  objectsArray,
  fieldName,
  newValue,
  fieldsToRemove = [] // مقدار پیش‌فرض آرایه خالی
) {
  if (!Array.isArray(objectsArray) || objectsArray.length === 0) {
    throw new Error("The first argument must be a non-empty array.");
  }

  if (typeof fieldName !== "string" || fieldName.trim() === "") {
    throw new Error("The field name must be a valid string.");
  }

  if (!Array.isArray(fieldsToRemove)) {
    throw new Error("The fieldsToRemove parameter must be an array.");
  }

  return objectsArray.map((obj) => {
    // کپی کردن شیء و اعمال مقدار جدید برای فیلد مورد نظر
    let updatedObject = { ...obj, [fieldName]: newValue };

    // حذف فیلدهای مشخص‌شده در `fieldsToRemove`
    fieldsToRemove.forEach((field) => delete updatedObject[field]);

    return updatedObject;
  });
}
